<section class="news-section container">
  <div class="action-bar">
    <button
      mat-raised-button
      class="addition_button"
      (click)="addCreationPage()"
    >
      + Add News
    </button>
  </div>

  <div class="news-header bg-white">
    <h1>News List</h1>
    <p class="subtitle">Manage all scroller news items here</p>
  </div>
</section>
